export interface AnnouncementSeed {
  id: string;
  key: string;
  type: 'info' | 'warning' | 'success' | 'general';
  priority: 'high' | 'medium' | 'low';
  daysAgo: number;
}

/** Product news, newest first. Copy lives in the locale files. */
export const ANNOUNCEMENT_SEED: AnnouncementSeed[] = [
  { id: 'drbfm-knowledge-references', key: 'drbfmKnowledge', type: 'success', priority: 'high', daysAgo: 0 },
  { id: 'chat-rag-quality', key: 'chatQuality', type: 'success', priority: 'high', daysAgo: 1 },
  { id: 'audit-operations', key: 'auditOperations', type: 'success', priority: 'medium', daysAgo: 2 },
  { id: 'help-refresh', key: 'helpRefresh', type: 'info', priority: 'low', daysAgo: 3 },
];
